import React from 'react';
import html from '../../assets/logo/html.png';
import css from '../../assets/logo/css.png';
import javascript from '../../assets/logo/javascript.png';
import react from '../../assets/logo/react.png';
import bootstrap from '../../assets/logo/bootstrap.png';
import tailwind from '../../assets/logo/tailwind-css.png';
import daisyui from '../../assets/logo/daisyui.png';
import figma from '../../assets/logo/figma.png';
import firebase from '../../assets/logo/firebase.png';
import git from '../../assets/logo/git.png';

const FrontEndSkills = () => {
    return (
        <div data-aos="fade-up" data-aos-duration="2000">
            {/* -----------front end skills section----------- */}
            <div className="flex items-center mb-4">
                <span className="h-0.5 bg-accent w-24"></span>
                <p className="ml-3">Front-end skills & tools</p>
            </div>
            <div className="all-glass grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3">
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={html} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">HTML5</h2>
                            <p>My progress in HTML5</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={css} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">CSS3</h2>
                            <p>My progress in CSS3</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={javascript} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">JavaScript</h2>
                            <p>My progress in JavaScript</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="75"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={react} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">React JS</h2>
                            <p>My progress in React JS</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="85"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={bootstrap} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Bootstrap5</h2>
                            <p>My progress in Bootstrap5</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={tailwind} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Tailwind CSS</h2>
                            <p>My progress in Tailwind CSS</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={daisyui} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">DaisyUI</h2>
                            <p>My progress in DaisyUI</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={firebase} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Google Firebase</h2>
                            <p>My progress in Firebase</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={git} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Git & Github</h2>
                            <p>My progress in Git</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="85"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={figma} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Figma</h2>
                            <p>My progress in Figma</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="85"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FrontEndSkills;
